import React from "react";
import type { DateSearchItem } from "../sp/portalSearchTypes";

type Props = {
  item: DateSearchItem;
};

function PortalPCDateField({ item }: Props) {
  return (
    <div className="portalPcRangeControl">
      <input
        type="date"
        className="portalPcDateInput"
        aria-label="活動日程（開始日）"
        value={item.startDate || ""}
        onChange={(e) => item.setStartDate(e.target.value)}
      />
      <span className="portalPcRangeSep">〜</span>
      <input
        type="date"
        className="portalPcDateInput"
        aria-label="活動日程（終了日）"
        value={item.endDate || ""}
        onChange={(e) => item.setEndDate(e.target.value)}
      />
    </div>
  );
}

export default PortalPCDateField;
